// Translate auth backend error messages to Estonian. Covers both legacy
// Supabase strings (still possible during the staged migration) and Better
// Auth strings emitted by the new backend.
export function translateAuthError(errorMessage: string): string {
  if (!errorMessage) {
    return "Tundmatu viga autentimisel. Palun proovi hiljem uuesti.";
  }

  // --- credential / verification ---
  if (errorMessage.includes("Invalid login credentials") ||
      errorMessage.includes("Invalid email or password") ||
      errorMessage.includes("INVALID_EMAIL_OR_PASSWORD")) {
    return "Vale e-posti aadress või parool. Palun proovi uuesti.";
  }
  if (errorMessage.includes("Email not confirmed") ||
      errorMessage.includes("Email not verified") ||
      errorMessage.includes("EMAIL_NOT_VERIFIED")) {
    return "Palun kinnita oma e-posti aadress. Kontrolli oma postkasti ja kliki kinnituslingil.";
  }
  if (errorMessage.includes("User already registered") ||
      errorMessage.includes("User already exists") ||
      errorMessage.includes("USER_ALREADY_EXISTS")) {
    return "Selle e-posti aadressiga on juba konto registreeritud. Palun logi sisse või taasta parool.";
  }
  if (errorMessage.includes("Password should be at least") ||
      errorMessage.includes("PASSWORD_TOO_SHORT")) {
    return "Parool peab olema vähemalt 8 tähemärki pikk.";
  }

  // --- password reset ---
  if (errorMessage.includes("Invalid token") ||
      errorMessage.includes("INVALID_TOKEN") ||
      errorMessage.includes("expired token")) {
    return "Lähtestamise link on aegunud või kehtetu. Palun küsi uus link.";
  }
  if (errorMessage.includes("Invalid password") ||
      errorMessage.includes("INVALID_PASSWORD")) {
    return "Vale praegune parool. Palun proovi uuesti.";
  }

  // --- session / authorization ---
  if (errorMessage.includes("Unauthorized") ||
      errorMessage.includes("UNAUTHORIZED")) {
    return "Sessioon on aegunud. Palun logi uuesti sisse.";
  }

  // --- rate limiting / mail / network ---
  if (errorMessage.includes("Email rate limit exceeded") ||
      errorMessage.includes("over_email_send_rate_limit")) {
    return "Liiga palju e-kirjade saatmise katseid. Palun proovi mõne minuti pärast uuesti või kasuta teist e-posti aadressi.";
  }
  if (errorMessage.includes("For security purposes")) {
    return "Turvalisuse huvides ei saa me kinnitada, kas sellise e-posti aadressiga kasutaja on olemas.";
  }
  if (errorMessage.includes("rate limit exceeded") ||
      errorMessage.includes("429") ||
      errorMessage.includes("TOO_MANY_REQUESTS")) {
    return "Liiga palju katseid lühikese aja jooksul. Palun proovi mõne minuti pärast uuesti.";
  }
  if (errorMessage.includes("timeout") ||
      errorMessage.includes("signup_timeout") ||
      errorMessage.includes("Päring aegus") ||
      errorMessage.includes("E-kirja saatmine aegus")) {
    return "Päring aegus. Palun proovi hiljem uuesti.";
  }
  if (errorMessage.includes("context deadline exceeded") ||
      errorMessage.includes("504")) {
    return "Päring aegus. Serveril võtab vastamine liiga kaua aega. Palun proovi hiljem uuesti.";
  }
  if (errorMessage.includes("Failed to fetch") ||
      errorMessage.includes("NetworkError")) {
    return "Võrguviga. Kontrolli oma internetiühendust ja proovi uuesti.";
  }

  return `Autentimise viga: ${errorMessage}`;
}

export const emailConfirmationMessage =
  "Registreerimine õnnestus! Palun kontrolli oma postkasti ja kinnita konto, klikkides saadetud e-kirjas olevale lingile. Pärast kinnitamist saad sisse logida.";
